var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('body',{staticClass:"hold-transition sidebar-mini"},[_c('div',{attrs:{"id":"layout"}},[_c('div',{staticClass:"wrapper1 zoom_class zoom-moz"},[_c('app-content'),_c('chat-bot')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }